module.exports = __webpack_public_path__ + "h5/img/404.1d12d9be.png";